/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import type React from 'react';

type TooltipIntercationsT = 'hover' | 'click';

type TooltipTypesT = 'tooltip' | 'toolbar';

type TooltipPlacementsT =
  | 'top'
  | 'bottom'
  | 'right'
  | 'left'
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end'
  | 'right-start'
  | 'right-end'
  | 'left-start'
  | 'left-end';

interface DSTooltipArrowT {
  placement: string;
  style: React.CSSProperties;
  arrowElementRef: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
}

interface DSTooltipT {
  containerProps: Object;
  innerRef: (ref: HTMLElement) => void;
  placement: TooltipPlacementsT;
  title: string | React.ReactElement;
  delayClose: number;
  delayOpen: number;
  interactionType: TooltipIntercationsT;
  triggerComponent: React.ReactNode;
  className: string;
  getIsOpen: (status: boolean) => void;
  onOpen: () => void | null;
  tooltipType: 'tooltip' | 'toolbar';
  showArrow: boolean;
  zIndex: number;
  offset?: [number | null | undefined, number | null | undefined];
  extraModifiers: Record<string, unknown>;
}

interface TooltipContainerT {
  className: string;
  showTooltip: boolean;
  style: React.CSSProperties;
  tooltipType: TooltipTypesT;
}

interface TooltipAnimationT {
  showTooltip: boolean;
}

export type { DSTooltipT, DSTooltipArrowT, TooltipContainerT, TooltipAnimationT };
